import get from 'lodash/get'

import { ReduxState } from '../../types'
import { SigningType } from '../../constants'

export const getSigningForm = (state: ReduxState, type: SigningType) => {
  const ret: Record<string, any> = {
    verificationCode: get(state, 'form.Signing.values.verificationCode', ''),
  }

  if (
    type === SigningType.Scoring &&
    get(state, 'form.TelcoScoringConsent.values.telcoScoringConsent') === true
  ) {
    ret.consentTelcoScoring = true
  }

  return ret
}
